import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class PageTitle extends React.Component {

    render() {
        return (
            <div className="header--page__title">
                {this.props.back && <Link to={this.props.back} className="btn--back">
                    <span className="u-vis-hide">Click here to go back</span>
                    <img src="/img/icon-arrowLeft--grey.svg" alt="" className="icon" />
                </Link>}
                <h2 className="text--light text--color text--40">{this.props.title}</h2>
            </div>
        )
    }
}

PageTitle.propTypes = {
    back: PropTypes.string,
    title: PropTypes.string.isRequired
};
